//#region Style constants
export const vodafoneColor = "#e60000";
export const vodafoneDark = '#C30A28';
export const vodafoneDoneColor = '#007c92';
export const vodafoneNotDoneColor = 'black';
export const vodafoneFont = "Vodafone Rg";
//#endregion

const possibleOrigins = [
  'https://a8bd37a176245aac0.awsglobalaccelerator.com'.toLowerCase(),
];

//#region URLs
export function getTicketURL() {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/getticket'
  }
  switch (process.env.NODE_ENV) {
    case "development":
      return 'https://localhost:3003/getticket'; //ToDo MSE6 domain
    case "none":
      return 'https://lp2.baby-yoda.rocks/getticket'; //ToDo MSE6 domain 
    case "production":
      return 'https://dein.vodafone.de/getticket';
  }
}
export function reOpentURL() {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/reopenticket'
  }
  switch (process.env.NODE_ENV) {
    case "development":
      return 'https://localhost:3003/reopenticket'; //ToDo MSE6 domain
    case "none":
      return 'https://lp2.baby-yoda.rocks/reopenticket'; //ToDo MSE6 domain
    case "production":
      return 'https://dein.vodafone.de/reopenticket';
  }
}
export function cancelURL() {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/cancelticket'
  }
  switch (process.env.NODE_ENV) {
    case "development":
      return 'https://localhost:3003/cancelticket';
    case "none":
      return 'https://lp2.baby-yoda.rocks/cancelticket'; //ToDo MSE6 domain
    case "production":
      return 'https://dein.vodafone.de/cancelticket';
  }
}

export function getSlotsURL() {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/getslots'
  }
  switch (process.env.NODE_ENV) {
    case "development":
      return 'https://localhost:3003/getslots';
    case "none":
      return 'https://lp2.baby-yoda.rocks/getslots';
    case "production":
      return 'https://dein.vodafone.de/getslots';
  }
}

export function bookSlotURL() {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/bookslot'
  }
  switch (process.env.NODE_ENV) {
    case "development":
      return 'https://localhost:3003/bookslot';
    case "none":
      return 'https://lp2.baby-yoda.rocks/bookslot';
    case "production":
      return 'https://dein.vodafone.de/bookslot';
  }
}

export function refreshCordinates(): string {
  if (possibleOrigins.indexOf(window.location.origin.toLowerCase()) > -1) {
    return window.location.origin + '/coordinates'
  }
  switch (process.env.NODE_ENV) {
    case 'development': return 'https://localhost:3003/coordinates';
    case 'none': return 'https://lp2.baby-yoda.rocks/coordinates';
    case 'production': return 'https://dein.vodafone.de/coordinates';
  }
}


// export const getTicketURLTest = 'https://lp.baby-yoda.rocks/getticket';
// export const reOpenURLTest = 'https://lp.baby-yoda.rocks/reopenticket';
// export const cancelURLTest = 'https://lp.baby-yoda.rocks/cancelticket';

// export const getTicketURLLocal = 'https://localhost:3005/getticket';
// export const reOpenURLLocal = 'https://localhost:3005/reopenticket';
// export const cancelURLLocal = 'https://localhost:3005/cancelticket';
//#endregion

//#region page strings
export const reopenable = "reopenable";
export const cancelable = "cancelable";


export const appointable = "schedule";
export const appointablePopupDialog = "what would you like to schedule?  ";

export const appointableSuccess = "schedule has succedded";
export const appointableFailure = "schedule has failed!";
export const reappointable = "reappointable";

export const reappointablePopupDialog = "what would you like to reappoint ?  ";
export const reappointablelSuccess = "reappointment has succedded";
export const reappointableFailure = "reappointment has failed!";

export const cancelDialogString = 'Dein Anschluss ist wieder störungsfrei und du willst dein Ticket stornieren?';
export const cancelSuccess = 'Dein Ticket wurde erfolgreich storniert. Wir wünschen dir noch einen schönen Tag.';
export const cancelFailure = 'Ticket nicht erfolgreich störniert';
export const reopenSuccess = 'Dein Ticket wurde erfolgreich wiedergeöffenet. Wir wünschen dir noch einen schönen Tag.';
export const reopenFailure = 'Ticket nicht erfolgreich wiedergeöffenet';
export const reOpenDialogString = 'Dein Anschluss ist noch nicht störungsfrei und du willst dein Ticket wieder öffnen?';
//#endregion

//#region mock response from anypoint
export function getTimeline() {
  return {
    "woNum": "15708079",
    "region": "B",
    "woStatus": "PROGRESS",
    "woStatusText": "In Progress",
    "cancelable": true,
    "reopenable": true,
    //rename scheudal to "appointable"
    "appointable": true,
    //toggle for test
    "reappointable": true,
    "tripStarted": false,
    "workStarted": false,

    "creationDate": "2020-10-01",
    "activities": [
      {
        "activityCode": "*PUO",
        "status": "ACTV",
        "activityStart": {
          "startDate": "01/10/2020",
          "startTime": "08:17:00"
        },
        "activityFinish": {
          "finishDate": "25/10/2020",
          "finishTime": "08:45:00"
        },
        "customerMessage": "Dein Anliegen wurde unserem technischen Außendienst zur weiteren Bearbeitung zugewiesen."
      }, {
        "activityCode": "*PUO",
        "status": "ACTV",
        "activityStart": {
          "startDate": "01/10/2020",
          "startTime": "08:17:00"
        },
        "activityFinish": {
          "finishDate": "25/10/2020",
          "finishTime": "08:46:00"
        },
        "customerMessage": "Dein Anliegen wurde unserem technischen Außendienst zur weiteren Bearbeitung zugewiesen."
      },
      {
        "activityCode": "*PUO",
        "status": "COMP",
        "activityStart": {
          "startDate": "01/10/2020",
          "startTime": "08:17:00"
        },
        "activityFinish": {
          "finishDate": "25/10/2020",
          "finishTime": "08:47:00"
        },
        "customerMessage": "Dein Anliegen wurde unserem technischen Außendienst zur weiteren Bearbeitung zugewiesen."
      }
    ],
    "techType": 5,
    "workOrderType": {
      "WOCode": "AFA",
      "WODesc": "AFA-Analog Fehler Aussen"
    },
    "appointmentStart": '2021-04-21T08:00:00Z',
    "appointmentEnd": '2021-04-21T12:00:00Z',
    "street": "Michael-Schumacher-Strasse",
    "houseNo": "1",
    "zip": "50170",
    "city": "Kerpen",
    "country": "DE",
    "gpsLong": 6.3764120,
    "gpsLat": 50.7905001,
    "seFirstName": "Fritz",
    "seLastName": "Müller",
    "seCompany": "Blitz Elektro AG",
    "sePhone": "+49 7512 12345",
    "sePhoto": "https://photo.example.com/f.mueller/shot.jpg",
    "seGpsLong": 6.6764152,
    "seGpsLat": 50.8905228,
    "seEta": "2021-04-21T07:58:00",
    'workOrderTypeIndicator': 'INSTALL'
  };
}
//#endregion
